export default __webpack_public_path__ + "static/media/step_5.98377e11.svg";